import toMap from '~/misc/toMap';

export default toMap([
  'SEARCH_RESULTS_TOGGLE',
  'SEARCH_RESULTS_STATICMAP_URL_CACHED',
  'TOGGLE_LOADPHONE',
  'LOADS_PREMIUM_TOOLTIP_CLOSED',
  'SEARCH_LOAD_ACTIVE',
  'SEARCH_LOAD_INACTIVE',
  'LOADS_SKIP_BOOKNOW',
  'LOADS_TOGGLED_ROUTE_TRUCK_STOPS',
  'LOADS_TOGGLED_ROUTE_WEIGHT_STATIONS',
  'LOADS_TOGGLED_ROUTE_FUEL_PRICES',
  'LOADS_POINTED',
  'LOADS_FETCHED_ROUTE_RELATED_DATA',
  'LOADS_FETCHED_ROUTE_LOCATIONS',
  'LOADS_FETCHED_ROUTE_WEIGHT_STATIONS',
  'LOADS_FETCHED_ROUTE_TRUCK_STOPS',
  'LOADS_FETCHED_ROUTE_FUEL_PRICES',
  'LOADS_BROKER_SHOW_SIGNLOGIN_BTN',
  'LOADS_BROKER_HIDE_SIGNLOGIN_BTN',
  'lOADS_VERIFY'
]);



// WEBPACK FOOTER //
// ./src/modules/loads/types.js